module.exports = __webpack_public_path__ + "img/digital@2x.00da43d1.png";